import type { IIntegration } from "@/types/Integrations/IIntegration";

const teamsIntegrationModalOpened = ref(false);
const slackIntegrationModalOpened = ref(false);

const selectedIntegration = ref<IIntegration<unknown> | undefined>(undefined);

export default () => {
    return {
        teamsIntegrationModalOpened,
        slackIntegrationModalOpened,
        selectedIntegration,
    };
};
